/**
 * Permission-aware navigation helpers (frontend). The server remains the
 * authority for authorization; this only decides what to SHOW. Mirrors the
 * TABS[].roles gating used in App.js in a reusable form.
 */

/** Can a role see a nav entry whose allowed roles are `roles`? */
export function canAccessTab(role, roles) {
  return Array.isArray(roles) && roles.includes(role);
}

/** Filter a list of tab configs to those visible to `role`. */
export function visibleTabs(tabs, role) {
  return (tabs || []).filter((t) => canAccessTab(role, t.roles));
}

/** Merchant-team roles (used by the Merchant Command Center / merchant features). */
export const MERCHANT_TEAM_ROLES = ["admin", "global_bd", "commercial_intelligence_read", "frontend_qa", "ksa_bd", "oman_bd", "viewer"];

export function isMerchantTeam(role) {
  return MERCHANT_TEAM_ROLES.includes(role);
}
